import React, { useState } from "react";
import { Button, message } from "antd";

export default function PreviewBtn({ text }) {
  const link = `${process.env.REACT_APP_URL}${text?.collection_link}`;
  const [btnName, setBtnName] = useState(link);
  const copyLink = () => {
    navigator.clipboard.writeText(link);
    message.success("Link copied to clipboard");
  };
  return (
    <Button
      className="table-control"
      size="large"
      style={{
        width: "100%",
        fontSize:14
      }}
      onClick={() => {
        window.open(
          `${process.env.REACT_APP_URL}${text?.collection_link}?type=PREVIEW`
        );
      }}
    >
      Preview
    </Button>
  );
}
